// ─── «Inscritos»: UNA regla para el servidor y el web ───────────────────────
// Inscrito es toda inscripción que no sea un retiro (`dropped`):
//   · en un período en curso, los que están cursando (`enrolled`);
//   · en uno cerrado, los que cursaron (`approved`, `failed`).
// Es lo mismo que mantiene el servidor en `currentEnrollment`: suma al
// inscribir y resta solo al retirar.
//
// VIVE EN EL DOMINIO DESDE EL PR 3A. Antes estaba en el web
// (lib/enrollment-count.ts) y copiada en el script de LABTS; ahora el conteo de
// inscritos también lo hace el servidor (getTermSectionsOverview), y tres
// copias de la misma regla terminan diciendo tres cosas.
/** Los estados que cuentan como inscrito (para consultas `in`). */
export const COUNTED_ENROLLMENT_STATUSES = ['enrolled', 'approved', 'failed'];
export function countsAsEnrolled(enrollment) {
    return COUNTED_ENROLLMENT_STATUSES.includes(enrollment.status);
}
//# sourceMappingURL=enrollment-count.js.map